const Video = require('@splinter/video');

module.exports = Video;
